import {
  Component,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { NotesService } from "../../../services/notes.service";
import { NoteGroupDescriptionModel } from "../../../models/notes/note-group-description.model";
import { _testNotesGlobals } from "../../../modules/notes/models/Notes.models";
import { MessagingService } from "../../../services/messaging.service";
import { NoteDataModel } from "../../../models/notes/note-data.model";
import { EnumValidValueItemModel } from "../../../models/enum/enum-valid-value-item.model";
import { StaticDataService } from "../../../services/static-data.service";
import { NoteCategoryDataModel } from "../../../models/notes/note-category-data.model";
import { NoteTypeDataModel } from "../../../models/notes/note-type-data.model";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { TdoNoteFilterModel } from "./models/tdo-note-filter.model";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { UiService } from "../../../services/ui.service";
import { MessagingConstants } from "../../../models/MessagingConstants";
import { Globals } from "../../../globals";
import {
  TdoNoteAssociatedObject,
  TdoNoteSaveModel,
} from "./models/tdo-note-save-model";
import { TdoNoteQueryModel } from "./models/tdo-note-query.model";
import { TdoNotesMultiselectMenuComponent } from "./tdo-notes-multiselect-menu/tdo-notes-multiselect-menu.component";
import { TdoUserConfigurationModel } from "../../../models/configuration/user/tdo-user-configuration.model";
import { NavigationStart, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { AuthenticationService } from "../../../modules/auth/services/authentication.service";
import { UserRoleEnum } from "../../../models/enum/user-role.enum";
import { NoteTypeEnum } from "../../../models/enum/note-type.enum";
import { NoteCategoryEnum } from "../../../models/enum/note-category.enum";
import { TdoNotesExpandedComponent } from "./tdo-notes-expanded/tdo-notes-expanded.component";

@Component({
  selector: "app-tdo-notes",
  templateUrl: "./tdo-notes.component.html",
  styleUrls: ["./tdo-notes.component.scss"],
})
export class TdoNotesComponent implements OnInit, OnDestroy {
  @ViewChild("categoryDropdown")
  categoryDropdown: TdoNotesMultiselectMenuComponent;
  @ViewChild("typeDropdown") typeDropdown: TdoNotesMultiselectMenuComponent;

  @Input() listenToNoteQueryEvents: boolean = true;

  @Input() PatientID: string;
  @Input() CaseID: string;
  @Input() PatientName: string;
  @Input() NoteGroupId: string;
  @Input() ParentObjectName: string;
  @Input() ObjectId: string;

  @Input() categoryFilters: any[] = [];
  @Input() filteredMode: boolean = false;
  @Input() showAllFilter: any = { displayValue: "Show all", selected: true };
  @Input() isDockedLeft = false;
  @Input() isMinimized = false;
  @Input() isMaximized = false;
  @Input() currentSize = "290px";

  isShowModuleSpecificNotes = true;

  notesNormalSize = "290px";
  notesMaximunSize = "780px";

  messagingSubscription: any;
  hideFilterButton: boolean = false;
  isLoading: boolean = false;
  deleteMode: boolean = false;
  hideFilters: boolean = true;
  notes: NoteDataModel[] = [];
  alertNotes: NoteDataModel[] = [];
  filteredNotes: NoteDataModel[] = [];

  objectsRelatedToPatient: NoteGroupDescriptionModel[] = [];
  selectedRelatedObjects: NoteGroupDescriptionModel[] = [];
  selectedTypes: string[];
  isShowSettings;

  storedUser;

  notesCategories: EnumValidValueItemModel[] = [];
  notesTypes: EnumValidValueItemModel[] = [];

  autoSaveMsDelay: number = 2000;
  lastDataNote: NoteDataModel;

  storedNoteFilterSettings: TdoNoteFilterModel;
  private allCategoryModel: NoteCategoryDataModel;
  private allTypeModel: NoteTypeDataModel;

  private isInitialized: boolean;
  private timeoutInstanceId: string;
  private subscriptions: Subscription[] = [];

  lastQueryModel: TdoNoteQueryModel;

  constructor(
    private notesGlobals: _testNotesGlobals,
    private notesService: NotesService,
    private messagingService: MessagingService,
    private el: ElementRef,
    private staticDataService: StaticDataService,
    private authenticationService: AuthenticationService,
    private dialog: MatDialog,
    public uiService: UiService,
    private router: Router,
    public globals: Globals
  ) {
    this.allCategoryModel = new NoteCategoryDataModel();
    const categoryAllEnum = new EnumValidValueItemModel();
    categoryAllEnum.ValidValueItemId = "storedCategoryAll";
    categoryAllEnum.ItemDisplayValue = "Show All Categories";
    this.allCategoryModel.enumNoteCategory = categoryAllEnum;
    this.allCategoryModel.enumNoteCategoryID = categoryAllEnum.ValidValueItemId;

    this.allTypeModel = new NoteTypeDataModel();
    const typeAllEnum = new EnumValidValueItemModel();
    typeAllEnum.ValidValueItemId = "storedTypeAll";
    typeAllEnum.ItemDisplayValue = "Show All Types";
    this.allTypeModel.enumNoteType = typeAllEnum;
    this.allTypeModel.enumNoteTypeID = typeAllEnum.ValidValueItemId;
    this.storedUser = JSON.parse(localStorage.getItem("storedUser"));
    this.currentSize = localStorage.getItem("currentNoteSize") || this.notesNormalSize;

    const storedFilterSettings = localStorage.getItem("noteFilterSettings");
    if (storedFilterSettings) {
      this.storedNoteFilterSettings = JSON.parse(
        storedFilterSettings
      ) as TdoNoteFilterModel;
    } else {
      this.storedNoteFilterSettings = new TdoNoteFilterModel();
      this.storedNoteFilterSettings.notesCategories.push(this.allCategoryModel);
      this.storedNoteFilterSettings.notesTypes.push(this.allTypeModel);
    }
  }

  ngOnDestroy(): void {
    for (const sub of this.subscriptions) {
      sub.unsubscribe();
    }
  }

  onChangeNotesDock(dockSide: string) {
    if (dockSide === "left") {
      this.uiService.isNotesOnLeft = true;
    } else {
      this.uiService.isNotesOnLeft = false;
    }
  }

  toggleSize(size: string) {
    this.currentSize = size;
    this.isMinimized = false;
    localStorage.setItem("currentNoteSize", this.currentSize);
    this.uiService.isRightPanelMinimized = this.isMinimized;
  }

  saveFilterSettings() {
    localStorage.setItem(
      "noteFilterSettings",
      JSON.stringify(this.storedNoteFilterSettings)
    );
  }

  ngOnInit() {
    setTimeout(() => {
      this.isInitialized = true;
    }, 0.1);
    const sub = this.notesService.onNoteQueryRequest.subscribe((queryModel) => {
      this.lastQueryModel = queryModel;
      if (queryModel.objectId) {
        this.isShowModuleSpecificNotes = localStorage.getItem("isShowModuleSpecificNotes") === "true";
      }


      if (localStorage.getItem("isShowModuleSpecificNotes") === "true") {
        this.getNotes(queryModel);
      } else {
        const mod = new TdoNoteQueryModel();
        mod.patientId = this.globals.currentPatientId;
        this.getNotes(mod);
      }



    });
    this.subscriptions.push(sub);

    if (this.staticDataService.isReady) {
      this.notesCategories =
        this.staticDataService.getValidValueItemsByValidValueName(
          "enumNoteCategory"
        );
      this.notesTypes =
        this.staticDataService.getValidValueItemsByValidValueName(
          "enumNoteType"
        );
      this.getAlertNotes();
    } else {
      this.staticDataService.validValuesReadyEvent.subscribe({
        complete: () => {
          this.notesCategories =
            this.staticDataService.getValidValueItemsByValidValueName(
              "enumNoteCategory"
            );
          this.notesTypes =
            this.staticDataService.getValidValueItemsByValidValueName(
              "enumNoteType"
            );
          this.getAlertNotes();
        },
      });
    }

    this.messagingSubscription =
      this.messagingService.componentMessageCall.subscribe((response) => {
        if (
          response.event === MessagingConstants.PATIENT_CHANGED &&
          this.listenToNoteQueryEvents
        ) {
          this.storedNoteFilterSettings.isShowAlertNotes = true;
          this.alertNotes = [];
          this.notes = [];
          this.filteredNotes = [];
        }

        if (response.event === MessagingConstants.NOTES_MINIMIZE) {
          this.isMinimized = true;
          this.uiService.isRightPanelMinimized = true;
        }

        if (response.event === MessagingConstants.NOTES_CREATE_NOTE) {
          const model = response.data as TdoNoteSaveModel;
          this.saveDataNote(model);
        }

        if (response.event === MessagingConstants.NOTES_UPDATE_NEW_NOTE) {
          if (!this.notes.some((n) => n.NoteId === response.data.noteGroup.NoteId)) {
            this.notes.unshift(response.data.noteGroup);
          }
        }

        if (response.event === MessagingConstants.NOTES_REFRESH) {
          this.getNotes(this.lastQueryModel);
        }

        if (response.event === MessagingConstants.NOTES_CREATE_BLANK_NOTE) {
          const model = new TdoNoteQueryModel();
          model.patientId = this.globals.currentPatientId;
          model.objectId = this.globals.currentPatientCaseId;
          this.getNotes(model);

          this.ObjectId = response.data.ObjectId;
          this.ParentObjectName = response.data.ParentObjectName;
          this.PatientID = response.data.PatientID;
        }

        if (response.event === MessagingConstants.NOTES_FILTER_OBJECT) {
          let queryModel = new TdoNoteQueryModel();
          queryModel = response.data;
          this.getNotes(queryModel);
        }

        if (response.event === MessagingConstants.NOTES_FILTER) {
          this.storedNoteFilterSettings = response.data;
          if (this.storedNoteFilterSettings.notesTypes.length === 0) {
            this.storedNoteFilterSettings.notesTypes.push(this.allTypeModel);
          }
          if (this.storedNoteFilterSettings.notesCategories.length === 0) {
            this.storedNoteFilterSettings.notesCategories.push(
              this.allCategoryModel
            );
          }

          if (this.storedNoteFilterSettings.isCondensedView) {
            this.storedNoteFilterSettings.isFullView = false;
            this.storedNoteFilterSettings.isShowModifiedOn = false;
            this.storedNoteFilterSettings.isShowCreatedBy = false;
            this.storedNoteFilterSettings.isShowCreatedOn = false;
            this.storedNoteFilterSettings.isShowModifiedBy = false;
          }

          this.saveFilterSettings();
          this.filteredMode = true;
          this.filterNotes();
        }
      });
  }

  sortNotes() {
    this.notes = this.notes.sort((a, b) => {
      const d1 = new Date(a.xauditModifiedOn);
      const d2 = new Date(b.xauditModifiedOn);
      if (d1 > d2) return -1;
      if (d2 > d1) return 1;
      return 0;
    });
  }

  filterNotes() {
    if (
      this.storedNoteFilterSettings.notesCategories.length === 1 &&
      this.storedNoteFilterSettings.notesCategories[0].enumNoteCategoryID ===
        this.allCategoryModel.enumNoteCategoryID &&
      this.storedNoteFilterSettings.notesTypes.length === 1 &&
      this.storedNoteFilterSettings.notesTypes[0].enumNoteTypeID ===
        this.allTypeModel.enumNoteTypeID
    ) {
      this.filteredNotes = this.notes;
      return;
    }

    const selectedCategoryIds =
      this.storedNoteFilterSettings.notesCategories.map(
        (h) => h.enumNoteCategoryID
      );
    const selectedTypeIds = this.storedNoteFilterSettings.notesTypes.map(
      (h) => h.enumNoteTypeID
    );

    this.filteredNotes = this.notes.filter((note) => {
      const matchesCategory =
        selectedCategoryIds.includes(
          this.allCategoryModel.enumNoteCategoryID
        ) ||
        note.dataNoteCategories.some((cat) =>
          selectedCategoryIds.includes(cat.enumNoteCategoryID)
        );
      const matchesType =
        selectedTypeIds.includes(this.allTypeModel.enumNoteTypeID) ||
        note.dataNoteTypes.some((type) =>
          selectedTypeIds.includes(type.enumNoteTypeID)
        );

      return matchesCategory && matchesType;
    });
  }

  setupCategoryFilters() {
    this.categoryFilters = [];
    this.notesCategories.forEach((cat) => {
      this.categoryFilters.push({
        displayValue: cat.ItemDisplayValue,
        selected: true,
      });
    });
  }

  getAlertNotes() {
    if (
      this.globals.currentPatientId !== "null" &&
      this.globals.currentPatientId !== "undefined" &&
      this.globals.currentPatientId !== null &&
      this.globals.currentPatientId !== undefined
    ) {
      this.notesService
        .getAlertNotes(this.globals.currentPatientId)
        .subscribe((alertRes) => {
          this.alertNotes = alertRes;
        });
    } else this.alertNotes = [];
  }

  async getNotes(model: TdoNoteQueryModel) {
    this.isLoading = true;
    if (model.categoryEnumId === NoteCategoryEnum.Insurance) {
      const InsuranceModel = { ...model };
      InsuranceModel.categoryEnumId = NoteCategoryEnum.InsuranceCardInfo;
      InsuranceModel.objectId = model.patientId;
      InsuranceModel.parentObjectName = "dataPatientInsuranceCard";
      const promises: any[] = [
        this.notesService.getNotes(InsuranceModel).toPromise(),
        this.notesService.getNotes(model).toPromise(),
      ];
      try {
        const results: any[] = await Promise.all(promises);
        if (results[0]) {
          this.notes = results[0];
        }
        if (results[1]) {
          this.notes.push(...results[1]);
        }

        // Filtrar duplicados por NoteId si hubiera
        this.notes = this.notes.filter(
          (note, index, self) =>
            index === self.findIndex((n) => n.NoteId === note.NoteId)
        );

        this.sortNotes();
        this.filterNotes();
        this.isLoading = false;
        this.messagingService.sendComponentMessage(
          MessagingConstants.NOTES_FILTER_READY,
          {}
        );
      } catch (err) {
        console.log("Error retrieving notes.");
      }
    } else {
      this.notesService.getNotes(model).subscribe((res) => {
        this.notes = res;
        // Filtrar duplicados por NoteId
        this.notes = this.notes.filter(
          (note, index, self) =>
            index === self.findIndex((n) => n.NoteId === note.NoteId)
        );

        this.sortNotes();
        this.filterNotes();
        this.isLoading = false;
        this.messagingService.sendComponentMessage(
          MessagingConstants.NOTES_FILTER_READY,
          {}
        );
      });
    }
  }

  saveDataNote(model: TdoNoteSaveModel) {
    const assoc = new TdoNoteAssociatedObject();
    assoc.parentObjectName = this.lastQueryModel.parentObjectName;
    assoc.objectId = this.lastQueryModel.objectId;
    model.patientId = this.lastQueryModel.patientId;

    const alreadyExistModel = model.associatedObjects.find(
      (p) =>
        p.parentObjectName === this.lastQueryModel.parentObjectName &&
        p.objectId === this.lastQueryModel.objectId
    );
    if (!alreadyExistModel) {
      model.associatedObjects.push(assoc);
    }

    // Filtrar duplicados antes de enviar al backend
    if (model.dataNote?.dataNoteCategories) {
      model.dataNote.dataNoteCategories = model.dataNote.dataNoteCategories.filter(
        (cat, index, self) =>
          index ===
          self.findIndex((c) => c.enumNoteCategoryID === cat.enumNoteCategoryID)
      );
    }

    if (model.dataNote?.dataNoteTypes) {
      model.dataNote.dataNoteTypes = model.dataNote.dataNoteTypes.filter(
        (type, index, self) =>
          index ===
          self.findIndex((t) => t.enumNoteTypeID === type.enumNoteTypeID)
      );
    }

    this.notesService.saveNote(model).subscribe((res) => {
      model.dataNote = res;

      // Antes de agregar la nota a this.notes, verificar si ya existe
      if (!this.notes.some((n) => n.NoteId === res.NoteId)) {
        this.notes.unshift(res);
      } else {
        // Si ya existe, actualizar
        const retModel = this.notes.findIndex((p) => p.NoteId === res.NoteId);
        if (retModel > -1) {
          this.notes[retModel] = res;
        }
      }

      this.filterNotes();
    });
  }

  onCloseClick(): void {
    this.messagingService.sendComponentMessage("Toggle-Notes-Display", {
      display: false,
    });
  }

  onSettingsClick() {
    this.isShowSettings = !this.isShowSettings;
  }

  onEmergencyInformationClick() {
    this.storedNoteFilterSettings.isShowAlertNotes =
      !this.storedNoteFilterSettings.isShowAlertNotes;
    this.saveFilterSettings();
  }

  onFilterClickOutside() {
    if (this.isShowSettings) {
      this.isShowSettings = false;
    }
  }

  onAddNoteClick() {
    const newDataNote = new NoteDataModel();
    newDataNote.Note = "";
    newDataNote.isLocked = false;
    newDataNote.xauditCreatedOn = new Date();
    newDataNote.xauditModifiedOn = new Date();
    newDataNote.xauditCreatedByUser = new TdoUserConfigurationModel();
    newDataNote.xauditModifiedByUser = new TdoUserConfigurationModel();
    const userNameArray = this.storedUser.fullname.split(" ");
    newDataNote.xauditCreatedByUser.FirstName = userNameArray[0];
    newDataNote.xauditCreatedByUser.LastName = userNameArray[1];
    newDataNote.xauditModifiedByUser.FirstName = userNameArray[0];
    newDataNote.xauditModifiedByUser.LastName = userNameArray[1];

    let noteType: NoteTypeDataModel;
    if (this.lastQueryModel && this.lastQueryModel.typeEnumId) {
      noteType = new NoteTypeDataModel();
      noteType.enumNoteTypeID = this.lastQueryModel.typeEnumId;
      noteType.enumNoteType = this.notesTypes.find(
        (p) => p.ValidValueItemId.toLowerCase() === noteType.enumNoteTypeID
      );
      newDataNote.dataNoteTypes.push(noteType);
    } else {
      noteType = new NoteTypeDataModel();
      noteType.enumNoteTypeID = "00000019-1000-0000-0000-000000000001"; // Default patient
      noteType.enumNoteType = this.notesTypes.find(
        (p) => p.ValidValueItemId.toLowerCase() === noteType.enumNoteTypeID
      );
      newDataNote.dataNoteTypes.push(noteType);
    }

    let noteCategory: NoteCategoryDataModel;
    if (this.lastQueryModel && this.lastQueryModel.categoryEnumId) {
      noteCategory = new NoteCategoryDataModel();
      noteCategory.enumNoteCategoryID = this.lastQueryModel.categoryEnumId;
      noteCategory.enumNoteCategory = this.notesCategories.find(
        (p) =>
          p.ValidValueItemId.toLowerCase() === noteCategory.enumNoteCategoryID
      );
      newDataNote.dataNoteCategories.push(noteCategory);
    } else {
      noteCategory = new NoteCategoryDataModel();
      noteCategory.enumNoteCategoryID = "00000018-1000-0000-0000-000000000001";
      noteCategory.enumNoteCategory = this.notesCategories.find(
        (p) =>
          p.ValidValueItemId.toLowerCase() === noteCategory.enumNoteCategoryID
      );
      newDataNote.dataNoteCategories.push(noteCategory);
    }

    this.filteredNotes.unshift(newDataNote);
  }

  onNoteInput(event: string, noteData: NoteDataModel) {
    const model = new TdoNoteSaveModel();
    model.text = noteData.Note;
    model.patientId = this.globals.currentPatientId;
    model.dataNote = noteData;

    if (!noteData.NoteId) {
      model.text = noteData.Note;
    }
    this.saveDataNote(model);
  }

  onFilterCategoryDropdownSelectionComplete(items: NoteCategoryDataModel[]) {
    if (items.length > 0) {
      this.storedNoteFilterSettings.notesCategories = items;
    } else {
      this.storedNoteFilterSettings.notesCategories = [this.allCategoryModel];
    }

    this.saveFilterSettings();
    this.filterNotes();
  }

  onFilterTypeDropdownSelectionComplete(items: NoteTypeDataModel[]) {
    if (items.length > 0) {
      this.storedNoteFilterSettings.notesTypes = items;
    } else {
      this.storedNoteFilterSettings.notesTypes = [this.allTypeModel];
    }

    this.saveFilterSettings();
    this.filterNotes();
  }

  onFilterCategorySettingsReset() {
    this.storedNoteFilterSettings.notesCategories = [this.allCategoryModel];
    this.categoryDropdown.clearCheckboxes();
    this.saveFilterSettings();
    this.filterNotes();
  }

  onFilterTypeSettingsReset() {
    this.storedNoteFilterSettings.notesTypes = [this.allTypeModel];
    this.typeDropdown.clearCheckboxes();
    this.saveFilterSettings();
    this.filterNotes();
  }

  onCheckboxChange(event: MatCheckboxChange) {
    switch (event.source.ariaLabel) {
      case "Full View":
        this.storedNoteFilterSettings.isFullView = event.checked;
        if (!this.storedNoteFilterSettings.isFullView) {
          this.storedNoteFilterSettings.isCondensedView = true;
        } else {
          this.storedNoteFilterSettings.isCondensedView = false;
        }
        break;
      case "Condensed View":
        this.storedNoteFilterSettings.isCondensedView = event.checked;
        if (!this.storedNoteFilterSettings.isCondensedView) {
          this.storedNoteFilterSettings.isFullView = true;
        } else {
          this.storedNoteFilterSettings.isFullView = false;
        }
        break;
      case "Created On":
      case "Created By":
      case "Modified On":
      case "Modified By":
        // Ajustar según la lógica deseada
        break;
    }

    this.saveFilterSettings();
  }

  isAllViewOptionsSelected() {
    // Implementa tu lógica si lo requieres
  }

  onExpandNotes() {
    const dialogConfig = {
      width: "90vw",
      height: "90vh",
      panelClass: "custom-dialog-container",
    };
    this.dialog.open(TdoNotesExpandedComponent, dialogConfig);
  }

  onNoteVisibilityClick() {
    this.isShowModuleSpecificNotes = !this.isShowModuleSpecificNotes;
    if (this.isShowModuleSpecificNotes) {
      this.getNotes(this.lastQueryModel);
      localStorage.setItem("isShowModuleSpecificNotes", "true");
    } else {
      const mod = new TdoNoteQueryModel();
      mod.patientId = this.globals.currentPatientId;
      localStorage.setItem("isShowModuleSpecificNotes", "false");
      this.getNotes(mod);
    }
  }

  isUserHasRoleToEdit() {
    return this.authenticationService.currentUserRolesIds.includes(
      UserRoleEnum.Notes
    );
  }

  onNoteChange(event: NoteDataModel) {
    const alertType = event.dataNoteTypes.find(
      (p) => p.enumNoteTypeID === NoteTypeEnum.Alert
    );
    if (alertType) {
      this.alertNotes.unshift(event);
    }
    if (event.xauditDeleted) {
      var noteIndex = this.filteredNotes.indexOf(event);
      if (noteIndex > -1) {
        this.filteredNotes.splice(noteIndex, 1);
      }
    }
  }
}
